import React, { FC } from "react";
import "./style.scss";
import { useTranslation } from "react-i18next";

const Loading = (props: { className?: string }) => {
  const { t } = useTranslation("app");

  return (
    <div className={`loading ${props.className}`}>
      <div className="loader-mobile"></div>
      <div className="loader"></div>
      <p>{t("loading")}</p>
    </div>
  );
};

export default Loading;

type PropsType = {
  style?: React.CSSProperties;
  className?: string;
  text?: string;
};

export const Spinner: FC<PropsType> = ({ style }) => {
  return (
    <div className="circle-spinner" style={style}>
      <div className="loader-mobile"></div>
    </div>
  );
};

export const BioLoadingSpinner: FC<PropsType> = ({ className, text }) => {
  return (
    <div className={`loading bio-loading ${className}`}>
      {text && <p dangerouslySetInnerHTML={{ __html: text }} />}

      <div className="bio-loading-spinner">
        {[...Array(12)].map((_, index) => (
          <div key={index} className="line"></div>
        ))}
      </div>
    </div>
  );
};
